import { z } from 'zod';

import { Timezone, Weekday } from '@willow/graphql-iso/src/app';
import { HourIncrement } from '@willow/types-iso';

export const DayAndTimeRange = z.object({
  startTime: HourIncrement,
  startDay: z.enum(Weekday),
  endTime: HourIncrement,
  endDay: z.enum(Weekday),
  timezone: z.enum(Timezone),
});
export type TDayAndTimeRange = z.infer<typeof DayAndTimeRange>;
